import React, { ReactNode } from 'react'

import { AstroSignSvg } from 'components/designSystem/svgr/AstroSignSvg'
import { ChatSvg } from 'components/designSystem/svgr/ChatSvg'
import { CigarSvg } from 'components/designSystem/svgr/CigarSvg'
import { CorkscrewSvg } from 'components/designSystem/svgr/CorkscrewSvg'
import { DumbbellSvg } from 'components/designSystem/svgr/DumbbellSvg'
import EyeQuestionSvg from 'components/designSystem/svgr/EyeQuestionSvg'
import { HeartSvg } from 'components/designSystem/svgr/HeartSvg'
import { HorseToySvg } from 'components/designSystem/svgr/HorseToySvg'
import { HouseSvg } from 'components/designSystem/svgr/HouseSvg'
import { LipsSvg } from 'components/designSystem/svgr/LipsSvg'
import { ManAnonymousSvg } from 'components/designSystem/svgr/ManAnonymousSvg'
import { RulesSvg } from 'components/designSystem/svgr/RulesSvg'
import { ScalesSvg } from 'components/designSystem/svgr/ScalesSvg'
import { WalletSvg } from 'components/designSystem/svgr/WalletSvg'
import { WomanAnonymousSvg } from 'components/designSystem/svgr/WomanAnonymousSvg'
import { DatingFields } from 'components/page/DatingProfile/DatingProfile.constants'
import { GQLDatingGoals, GQLGender } from 'generated-graphql/graphql'

const iconProps = {
  width: 24,
  height: 24,
  color: 'currentColor',
}

export const iconsGoals: Record<string, ReactNode> = {
  [GQLDatingGoals.FlirtationAndDating]: <LipsSvg {...iconProps} />,
  [GQLDatingGoals.SeriousRelationship]: <HeartSvg {...iconProps} />,
  [GQLDatingGoals.FriendlyCommunication]: <ChatSvg {...iconProps} />,
  [GQLDatingGoals.WillDecideWhenMeet]: <EyeQuestionSvg {...iconProps} />,
}

/**
 * TODO: добавить поле вера
 */
export const iconsText: Record<
  Exclude<DatingFields, DatingFields.Education>,
  ReactNode | ((gender: GQLGender) => ReactNode)
> = {
  [DatingFields.MaterialStatus]: <WalletSvg {...iconProps} />,
  [DatingFields.HomeStatus]: <HouseSvg {...iconProps} />,
  [DatingFields.Children]: <HorseToySvg {...iconProps} />,
  [DatingFields.Alcohol]: <CorkscrewSvg {...iconProps} />,
  [DatingFields.Smoking]: <CigarSvg {...iconProps} />,
  [DatingFields.Orientation]: <HeartSvg {...iconProps} />,
  [DatingFields.Appearance]: (gender: GQLGender) =>
    gender === GQLGender.M ? (
      <ManAnonymousSvg {...iconProps} />
    ) : (
      <WomanAnonymousSvg {...iconProps} />
    ),
  [DatingFields.Constitution]: <DumbbellSvg {...iconProps} />,
  [DatingFields.Height]: <RulesSvg {...iconProps} />,
  [DatingFields.Weight]: <ScalesSvg {...iconProps} />,
  [DatingFields.AstroSign]: <AstroSignSvg {...iconProps} />,
}
